const helper = {
    EPIC_JWT: "EPIC_JWT",
    EPIC_PROFILE_ID: "EPIC_PROFILE_ID",
    EPIC_REFRESH_TOKEN: "EPIC_REFRESH_TOKEN",
    EPIC_USER_DATA: "EPIC_DATA",
    EPIC_USER_ROLE: "EPIC_USER_ROLE",
    EPIC_SUBSCRIPTION_EXPIRATION: "EPIC_SUBSCRIPTION_EXPIRATION",
    EPIC_LOGOUT_REASON: "EPIC_LOGOUT_REASON",
    EPIC_CLIENT_IP: "EPIC_CLIENT_IP",
} as const;
export default helper;
